import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { isExpired } from "./jwt"; // ตามไฟล์ utils ที่ให้ไปก่อนหน้า

export default function RequireAuth() {
  const { sessionId, logout } = useAuth();
  const location = useLocation();

  // ไม่มี token -> ส่งไป login พร้อมจำหน้าเดิม
  if (!sessionId) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  // หมดอายุ -> เคลียร์แล้วส่งไป login
  if (isExpired(sessionId)) {
    logout();
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}
